import React from 'react';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { OverduePaymentBanner } from 'app/src/components/OverduePaymentBanner';
import { View } from 'app/scripts/views/internal/view';
import { Auth } from 'app/scripts/db/auth';
import type { Organization } from 'app/scripts/models/organization';

export class OverdueBannerView extends View<Organization> {
  unmount: ReturnType<typeof renderComponent> | null = null;

  onDismiss = (bannerName: string) => {
    Auth.me().dismiss(bannerName);
    this.remove();
  };

  render() {
    this.unmount = renderComponent(
      <OverduePaymentBanner
        id={this.model.get('id')}
        name={this.model.get('name')}
        displayName={this.model.get('displayName')}
        paidAccount={this.model.get('paidAccount')!}
        onDismiss={this.onDismiss}
      />,
      this.$el[0],
    );
    return this;
  }

  remove() {
    this.unmount?.();
    return super.remove(...arguments);
  }
}
